document.addEventListener('click', (event) => {
  const btn = event.target.closest('[data-upsell-add]');
  if (!btn) return;

  const variantId = btn.dataset.variantId;
  if (!variantId) return;

  btn.disabled = true;
  btn.textContent = '...';

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: ['cart-drawer', 'cart-count'],
      sections_url: window.location.pathname
    })
  })
    .then((res) => res.json())
    .then((state) => {
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(state);
      }
    })
    .catch(() => {
      btn.disabled = false;
      btn.textContent = 'Add';
    });
});
